const currencySymbolMap = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    ILS: '₪'
};

export default currencySymbolMap;
